import { render, staticRenderFns } from "./PointComfort.vue?vue&type=template&id=116bdf0d&scoped=true&"
import script from "./PointComfort.vue?vue&type=script&lang=js&"
export * from "./PointComfort.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "116bdf0d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('116bdf0d')) {
      api.createRecord('116bdf0d', component.options)
    } else {
      api.reload('116bdf0d', component.options)
    }
    module.hot.accept("./PointComfort.vue?vue&type=template&id=116bdf0d&scoped=true&", function () {
      api.rerender('116bdf0d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/map/Points/PointComfort.vue"
export default component.exports